import Vue from 'vue';
import router from './router';
import store from './store';
import VueHead from 'vue-head';
import VModal from 'vue-js-modal';
import VueCompositionApi from '@vue/composition-api';
import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import awsconfig from './tf-sls-aws-exports';

//import ApiError from './api'

import App from './App.vue';

//Amplify.configure(awsconfig);
Auth.configure(awsconfig);
API.configure(awsconfig);

Vue.use(VueCompositionApi);
Vue.use(VueHead);
Vue.use(VModal, { dialog: true });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
